<div
  class="flex w-[462px] flex-col gap-5 bg-surface-0 p-12 shadow-xl shadow-surface-200
    rounded-border">
  <div>
    <h3 class="l mb-2 font-medium text-surface-900" i18n>Forgot Password</h3>
    <small class="font-medium text-surface-600" i18n>
      Enter your email to reset your password
    </small>
  </div>

  <form [formGroup]="forgotForm">
    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon>
          <ng-icon
            name="phosphorEnvelopeSimple"
            class="text-xl text-primary"></ng-icon>
        </p-inputicon>
        <input
          pInputText
          type="text"
          fluid
          formControlName="email"
          name="email" />
      </p-iconfield>
      <label for="email">Email</label>
    </p-floatlabel>
  </form>

  <error-small-component></error-small-component>

  <div class="flex gap-2">
    <button
      pButton
      pRipple
      [outlined]="true"
      label="Cancel"
      class="w-full !text-sm"
      (click)="navigationService.back()"></button>
    <button
      pButton
      pRipple
      label="Submit"
      class="w-full !text-sm"
      (click)="submit()"></button>
  </div>
</div>
